import React, { useEffect, useState } from "react";
import Button from "../../../../common/element/Buttons";
import Table from "../../../../common/element/Table";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import { SubmitWorkerDocToClient } from "../../../../actions/provider-portal/worker/SubmitWorkerDocToClient";
import { GetAllDocsOfWorkerByDocType } from "../../../../actions/provider-portal/worker/GetAllDocsOfWorkerByDocType";
const OldDocument = ({
  docTypeName,
  compliance_doc_id,
  closeAddDocPannel,
  indivisualData,
  individual_id,
  indivisualID,
  clientId,
}) => {
  const [getAllDocsData, SetGetAllDocsData] = useState([]);
  const dispatch = useDispatch();
  const loginUserData = JSON.parse(localStorage.getItem("LoginUserData"));
  const { Tr, Th, Td, THead, TBody } = Table;
  const [sorting,setSorting]=useState({
    sort:"doc_name",
    order:"desc"
  })
  useEffect(() => {
    // individual_id, document_type_id
    dispatch(
      GetAllDocsOfWorkerByDocType({
        // provider_org_id: id,
        // sort:sorting.sort,
        // order:sorting.order,
        individual_id: indivisualID,
        document_type_id: docTypeName?.document_type?.document_type_id,
      })
    ).then((response) => {
      SetGetAllDocsData(response?.data);
    });
  }, [sorting]);
  const AddDoc = (data) => {
    let payload = {
      client_org_id: clientId?.organisation_id
        ? clientId?.organisation_id
        : individual_id?.client_assigns?.[0]?.organisation_id,
      document_id: data.document_id,
      checklist_doc_id: docTypeName?.checklist_doc_id,
      worker_id: individual_id?.worker_id,
      provider_org_id: loginUserData?.organisation_id,
      expiry_date:
      data?.expiry_date != null || data?.expiry_date != undefined
        ? new Date(data?.expiry_date)
        : "",
    };

    //     document_id:
    // client_org_id:
    // checklist_doc_id:
    // worker_id:

    dispatch(SubmitWorkerDocToClient(payload)).then((response) => {
      if (response.success) {
        closeAddDocPannel(true);
      }
    });
  };
  const handleSort = (column) => {
    setSorting((prevalue) => {
    return {
      ...prevalue,
      ["order"]: sorting.order === "asc" ? "desc" : "asc",
      ["sort"]: column,
    };
  });
}
  return (
    <>
    <div className="overflow-hidden border rounded-lg border-gray-200">
      <Table>
        <THead>
          <Tr>
            <Th>
              <span className="flex items-center gap-1"               
              onClick={() => handleSort("doc_name")}
              >
                Document name
                <svg
                          className={`transform ${sorting?.sort === "doc_name" &&
                            sorting?.order === "asc"
                            ? "rotate-180"
                            : ""
                            }`}
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                    stroke="#475467"
                    stroke-width="1.333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </Th>

            <Th className="w-64">Document type</Th>

            <Th className="w-64">
              <span className="flex items-center gap-1"                 
              onClick={() => handleSort("expiry_date")}
 >
                Expiry date
                <svg
                     className={`transform ${sorting?.sort === "expiry_date" &&
                      sorting?.order === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                    stroke="#475467"
                    stroke-width="1.333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </Th>
            <Th className="w-16"></Th>
          </Tr>
        </THead>
        <TBody>
          {getAllDocsData?.map((item) => {
            return (
              <Tr>
                <Td>{item?.doc_name?item?.doc_name:"-"}</Td>
                <Td>{docTypeName?.doc_type_name?docTypeName?.doc_type_name:"-"}</Td>
                <Td>
                  {item?.expiry_date != null || item?.expiry_date != undefined
                    ? moment(item?.expiry_date).format("DD/MM/YYYY")
                    : "-"}
                </Td>
                <Td>
                  <Button
                    className="text-blue-700 hover:text-gray-900 focus:text-gray-600"
                    onClick={() => AddDoc(item)}
                  >
                    Select
                  </Button>
                </Td>
              </Tr>
            );
          })}
        </TBody>
      </Table>
    </div>
           {!getAllDocsData || getAllDocsData?.length ==0 && (
            <div className="h-full w-full text-center mt-2">No data available, please add a document to your document library.</div>
          )}

    </>
  );
};

export default OldDocument;
